<template>
  <div class="">
    <tabs
      v-model="active"
      color="#4FD9D5"
      title-active-color="#4FD9D5"
      title-inactive-color="#999999"
      line-width="33.33%"
      :border="true"
      sticky
    >
      <tab v-for="(item, index) in tabs" :key="index" :title="item.title">
        <list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div class="item" v-for="(item, index) in list" :key="index">
            <div class="item-title">
              <div class="order-num">订单号：{{ item.order_sn }}</div>

              <div class="state" v-if="item.status == 0">待支付</div>
              <div class="state" v-if="item.status == 1">进行中</div>
              <div class="state" v-if="item.status == 2">待评价</div>
              <div class="state" v-if="item.status == 3">已评价</div>
              <div class="state" v-if="item.status == -1">已取消</div>
              <div class="state" style="color: #f48e97" v-if="item.status == 4">
                申请退款
              </div>
              <div class="state" v-if="item.status == 5">已退款</div>
              <div class="state" v-if="item.status == 6">退款失败</div>
            </div>

            <div class="user">
              <div class="user-img">
                <van-image
                  width="1rem"
                  height="1rem"
                  fit="cover"
                  :src="item.goods_thumb"
                />
              </div>
              <div>
                <div class="question">{{ item.title }}<template v-if="item.Tname"> - {{item.Tname}}</template></div>
                <div class="price">
                  ￥<span>{{ item.price }}</span>
                </div>
              </div>
            </div>

            <div class="item-btn">
              <div v-if="item.status == 1" @click="jump_chat(item)">
                进入咨询
              </div>
              <div v-if="item.status == 1" @click="orderConfirm(item)">
                确认完成
              </div>
            </div>
          </div>
        </list>
      </tab>
    </tabs>
  </div>
</template>

<script>
/**
@description:咨询订单
@createTime:2021-09-01
@create:wq
*/
import { Tab, Tabs, List, Dialog } from "vant";

export default {
  name: "",
  props: {},
  components: { Tab, Tabs, List, [Dialog.Component.name]: Dialog.Component },
  data() {
    return {
      active: 0,
      tabs: [
        { title: "全部", status: 0 },
        { title: "进行中", status: 1 },
        { title: "已完成", status: 2 },
      ],
      page: 0,
      loading: false,
      finished: false,
      list: [],
    };
  },
  computed: {},
  watch: {
    active() {
      this.loading = false;
      this.finished = false;
      this.page = 1;
      this.getList()
      // this.onLoad();
    },
  },
  mounted() {},
  created() {
      if(this.$route.query.id){
          this.active =1
      }
  },
  methods: {
    getList() {
      const status = this.tabs[this.active].status;
      this.api
        .teacherOrder({ type: 1, status: status, page: this.page })
        .then((res) => {
          if(this.page == 1){
            this.list = res.data.data
          }else{
            this.list = [...this.list, ...res.data.data];
          }
          if (res.data.to < res.data.per_page) {
            this.loading = true;
            this.finished = true;
          } else {
            this.loading = false;
            // this.finished = false;
          }
        });
    },
    orderConfirm(item) {
      Dialog.confirm({
        message: "确认完成该订单？",
      })
        .then(() => {
          this.api.teacherConfirmOrder({ id: item.id }).then(() => {
            this.page = 1;
            this.getList();
            this.Toast.success("确认成功");
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    chat(item) {
      // `/pages/users/msg/chat?id=${item.id}&oid=${item.oid}&s=${item.status}&t=${item.oStatus}&remind=${item.remind}`
      this.$router.push({
        path: "chat",
        query: {
          id: item.id,
          oid: item.oid,
          s: item.roomStatus,
          t: item.status,
          remind: item.remind,
        },
      });
    },
    evaluate(item) {
      this.$router.push({
        path: "evaluate",
        query: {
          id: item.id,
        },
      });
    },
    onLoad() {
      this.page++;
      this.getList();
    },

    cancelOrder(item) {
      this.api.cancelOrder({ id: item.id }).then(() => {
        item.status = -1;
        // this.list.splice(index, 1);
        this.Toast("取消成功");
      });
    },
    jump_chat(item) {
      // console.log(item);
      if (item.status == 0 || item.status == -1) return;
      this.$router.push({
        path: "chat",
        query: {
          id: item.room_id,
          oid: item.id,
          t: item.status,
          s: item.roomStatus,
          remind: item.remind,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.item {
  //   height: 2.56rem;
  background: #ffffff;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.16);
  border-radius: 5px;
  margin: 0.24rem;
  padding: 0 0.2rem;
  .item-title {
    border-bottom: 1px solid #f0f0f0;
    height: 0.8rem;
    display: flex;
    justify-content: space-between;
    align-items: center;

    font-size: 0.24rem;
    font-weight: 400;
    color: #999999;
  }
  .user {
    display: flex;
    align-items: center;
    padding: 0.36rem 0;
    .user-img {
      width: 1rem;
      height: 1rem;
      border-radius: 50%;
      overflow: hidden;
      margin-right: 0.22rem;
      flex-shrink: 0;
    }
    .question {
      font-size: 0.3rem;
      font-weight: 400;
      color: #666666;
    }
    .price {
      font-size: 0.24rem;
      font-weight: bold;
      color: #f9647d;
      span {
        font-size: 0.36rem;
      }
    }
  }
  .item-btn {
    font-size: 0.28rem;
    font-weight: 500;
    color: #4fd9d5;
    display: flex;
    justify-content: flex-end;
    padding-bottom: 0.16rem;
    > div {
      width: 1.68rem;
      height: 0.6rem;
      border-radius: 0.4rem;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba($color: #4fd9d5, $alpha: 0.1);
      border: 1px solid #4fd9d5;
      margin-right: 0.08rem;
      &:last-child {
        border: none;
        background: #4fd9d5;
        color: #ffffff;
        margin-right: 0;
      }
    }
  }
}
</style>
